import Vue from 'vue'
import Router from 'vue-router'
import store from '../vuex/store'

import b1tOkrainaMain from '../components/okraina/pages/main'
const b1tOkrainaCart = () => import('../components/okraina/pages/cart');
const b1tOkrainaActions = () => import('../components/okraina/pages/actions');
const b1tOkrainaCatalog = () => import('../components/okraina/pages/catalog');
const b1tOkrainaCatalogSection = () => import('../components/okraina/pages/catalog-section');

Vue.use(Router)

let router = new Router({
    hashbang: false,
    mode: "history",
    routes: [
        {
            path: "/",
            name: "main",
            component: b1tOkrainaMain
        },
        {
            path: "/cart/",
            name: "cart",
            component: b1tOkrainaCart
        },
        {
            path: "/actions/",
            name: "actions",
            component: b1tOkrainaActions
        },
        {
            path: "/catalog/",
            name: "catalog",
            component: b1tOkrainaCatalog
        },
        {
            path: "/catalog/:id/",
            name: "catalog-section",
            component: b1tOkrainaCatalogSection
        }
    ]
})

router.afterEach((to) => {
   
    if(to.name === "main") {
        store.dispatch('SET_MAIN_PAGE',true);
    } else {
        store.dispatch('SET_MAIN_PAGE',false);
    }

    store.dispatch('SET_LOADING',false);
})

router.beforeEach((to, from, next) => {
    store.dispatch('SET_LOADING',true);
    next();
})

export default router;